import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { closeModal } from './actions';

import Button from '../button/Button';
import Icon from '../icon/Icon';
import { H2 } from '../containers/Headers';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export const ToolTip = ({ content, title, closeModal }) => (
  <div data-testid='modal_toolip' className='tooltip p4-sm'>
    <Button
      className='responsive-display-2-1 prl2-sm modal-close'
      onClick={closeModal}
      aria-label='Close Modal'
      data-desc='alert__close_x'
    >
      <Icon name='x' alt='close icon' />
    </Button>
    {title && <H2>{title}</H2>}
    <div className='body-3 pt1-sm'>{content}</div>
  </div>
);

ToolTip.propTypes = {
  content: PropTypes.any.isRequired,
  title: PropTypes.string,
  // --
  closeModal: PropTypes.func.isRequired
};

ToolTip.defaultProps = {
  title: new TranslatedCopy({ id: 'gridwall.search.tooltip.title' }).toString()
};

export default connect(null, { closeModal })(ToolTip);
